<template>
  <v-card>
    <v-card-title>
      <span class="headline">Agendamento de {{calendar_values.horary_calendar.all_day ? 'atividade' : 'compromisso'}}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container grid-list-md>
        <v-form v-model="valid" ref="form">
          <v-layout wrap>
            <v-layout v-if="calendar_values.filterType === 'teams'" row wrap>
              <v-flex xs12>
                <v-text-field :disabled="calendar_values.hasOwnProperty('set_values_calendar') || !checkPermission('tasks', 'create')" :label="checkPermission('tasks', 'create') ? 'Nova Tarefa' : 'Sem permissão para criar novas tarefas'" maxlength="190" counter="190"  @keyup.native.esc="close(400)" @keyup.native.enter="save()" v-model="task.id_text" :rules="requiredRule(translate('table.tasks.field.id_text'),190)"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete :disabled="calendar_values.hasOwnProperty('set_values_calendar')" @change="getTeamUsers" label="Equipe" name="team" v-model="task.team_id" :items="calendar_values.teams" item-text="id_text" item-value="id" :filter="filterAutocomplete" clearable :rules="requiredRule('Equipe')"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete :disabled="!task.team_id" label="Responsável" name="responsible" v-model="user" :items="calendar_values.team_users" item-text="id_text" item-value="id" return-object :filter="filterAutocomplete" hint="O responsável será o mesmo usuário do agendamento" persistent-hint clearable></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-flex xs12 v-else>
              <v-flex xs12>
                <v-text-field :disabled="!checkPermission('tasks', 'create')" :label="checkPermission('tasks', 'create') ? 'Nova Tarefa' : 'Sem permissão para criar novas tarefas'" maxlength="190" counter="190"  @keyup.native.esc="close(400)" @keyup.native.enter="save()" v-model="task.id_text" :rules="requiredRule(translate('table.tasks.field.id_text'),190)"></v-text-field>
              </v-flex>
            </v-flex>
            <v-layout row wrap ref="date">
              <v-flex v-if="!calendar_values.horary_calendar.all_day" grow>
                <p-date-time
                              :label="translate('table.task_calendar.field.begin')"
                              v-model="calendar_values.horary_calendar.begin"
                              :rules="dateDiffRule(true, translate('table.task_calendar.field.begin'), calendar_values.horary_calendar.begin, calendar_values.horary_calendar.end, true)">
                </p-date-time>
              </v-flex>
              <v-flex grow>
                <p-date-time
                              :label="translate('table.task_calendar.field.end')"
                              v-model="calendar_values.horary_calendar.end"
                              :rules="!calendar_values.horary_calendar.all_day ? dateDiffRule(true, translate('table.task_calendar.field.end'), calendar_values.horary_calendar.begin, calendar_values.horary_calendar.end, true) : requiredRule(translate('table.task_calendar.field.end'))">
                </p-date-time>
              </v-flex>
            </v-layout>
            <v-flex xs12 sm6></v-flex>
            <v-flex xs12 sm6>
              <span v-if="!calendar_values.horary_calendar.all_day" class="duration-commitment" style="padding-top: -60px;">{{'Duração de ' + moment.duration(moment(calendar_values.horary_calendar.end).diff(calendar_values.horary_calendar.begin)).format("h [hrs] m [min]")+'.'}}</span>
            </v-flex>
            <v-flex xs12>
              <v-switch v-if="hasSwitch === 'dayGridMonth'" :label="'Compromisso'" :true-value="false" :false-value="true" v-model="calendar_values.horary_calendar.all_day"
                        @change="changeAllDay"></v-switch>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="save()">Salvar</v-btn>
      <v-btn class="mx-0" @click.native="close(400)" :loading="loading">Cancelar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  /* eslint-disable no-unneeded-ternary */

  import PDateTime from './../shared/PDateTime'
  import rules from './../../mixin/rules'
  import access from './../../mixin/access'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)

  export default {
    name: 'PCalendarInsert',
    mixins: [rules, access],
    components: {
      PDateTime
    },
    props: {
      valuse: [],
      hasSwitch: ''
    },
    data: () => ({
      radio_type: 1,
      fromTeam: false,
      task: {id: null, id_text: '', level: 1, team_id: null, user_id: null, connection_company_id: null, connection_id: null},
      defaultTask: {id: null, id_text: '', level: 1, team_id: null, user_id: null, connection_company_id: null, connection_id: null},
      user: null,
      calendar_values: {
        horary_calendar: {all_day: false, begin: '', end: ''},
        filterType: null,
        teams: null,
        team_users: []
      },
      loading: false,
      valid: false
    }),
    methods: {
      allowed: v => v === 0,
      // Preenche a equipe e filtra os usuários da equipe
      getTeamUsers (val) {
        this.user = null
        if (!val) {
          return
        }
        let team = this.calendar_values.teams.find((el) => { return el.id === val })
        this.calendar_values.team_users = team.users_team
      },
      calendarClick (values, fromTeam = false) {
        Object.assign(this.calendar_values, JSON.parse(JSON.stringify(values)))
        // Caso seja o dia todo tira a data inicio
        if (this.calendar_values.horary_calendar.all_day) {
          this.calendar_values.horary_calendar.begin = ''
        }
        // Quando é arrastado uma tarefa para a agenda de equipe, faz alguns tratamentos especificos
        if (values.hasOwnProperty('set_values_calendar')) {
          this.task.id_text = values.set_values_calendar.task_id_text
          this.task.team_id = values.set_values_calendar.team_id
          this.task.id = values.set_values_calendar.task_id
          // Preenche a equipe e filtra os usuários da equipe
          this.getTeamUsers(values.set_values_calendar.team_id)
          // verifica se o usuário veio de alguma conexão caso não tenha vindo significa q a tarefa é da propria empresa e pega o proprio usuário da empresa
          let user = this.calendar_values.team_users.find((val) => {
            return val.user_id === this.$auth.user().id && ((val.connection_company_id === this.$auth.user().company_id))
          }) || this.calendar_values.team_users.find((val) => {
            return val.user_id === this.$auth.user().id && val.connection_company_id === null
          })
          this.user = user
        }
        this.dialog = true
      },
      changeAllDay (val) {
        // this.calendar_values.horary_calendar.all_day = !val
        if (!val) {
          if (this.calendar_values.horary_calendar.end && this.calendar_values.horary_calendar.end.split(' ')[1] !== '00:00') {
            this.calendar_values.horary_calendar.end = moment(this.calendar_values.horary_calendar.end).add(1, 'days').format('YYYY-MM-DD HH:mm')
          }
        }
        this.calendar_values.horary_calendar.begin = moment(this.calendar_values.horary_calendar.begin).format(val ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm')
        this.calendar_values.horary_calendar.end = moment(this.calendar_values.horary_calendar.end).format(val ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm')
      },
      filterAutocomplete  (item, queryText, itemText) {
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(query) > -1
      },
      close () {
        this.$refs.form.resetValidation()
        this.$emit('close')
        this.user = null
        Object.assign(this.task, JSON.parse(JSON.stringify(this.defaultTask)))
        this.calendar_values.horary_calendar = {begin: '', end: '', all_day: false}
        // Exclui o set_values_calendar pois quando ele possui valor, alguns campos são bloqueados
        delete this.calendar_values.set_values_calendar
        this.$store.commit('loader/change_dialog', false)
        this.loading = false
      },
      save () {
        if (!this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
          return false
        }
        let _this = this
        this.loading = true
        this.$store.commit('loader/change_dialog', true)
        if (this.calendar_values.filterType === 'personal') {
          this.task.user_id = this.$auth.user().id
        } else {
          this.task.user_id = this.user ? this.user.id : null
          this.task.connection_company_id = this.user ? this.user.connection_company_id : null
          this.task.connection_id = this.user ? this.user.connection_id : null
          this.calendar_values.horary_calendar.user_id = this.user ? this.user.user_id : null
          this.calendar_values.horary_calendar.company_id = (this.user && this.user.connection_company_id) ? this.user.connection_company_id : this.$auth.user().company_id
        }
        if (!this.task.id) {
          Object.assign(this.task, JSON.parse(JSON.stringify(this.calendar_values.horary_calendar)))
          // ao salvar a tarefa verifica se é dia inteiro, se sim é uma atividade se não é um compromisso
          this.task.commitment = (_this.calendar_values.horary_calendar.all_day === true) ? 0 : 1
          this.$http.post('api/create_task_for_calendar', this.task).then((res) => {
            this.calendar_values.horary_calendar.task_id = res.body.id
            let event = {
              id: -res.body.id,
              company_id: res.body.company_id,
              task_id: res.body.id,
              user_id: res.body.user_id,
              task: res.body,
              id_text: res.body.user ? res.body.user.id_text : 'Sem Responsável',
              user: res.body.user,
              company_id_text: res.body.company.id_text,
              company: res.body.company,
              title: res.body.identifier + ' - ' + res.body.id_text,
              start: res.body.commitment === 0 ? res.body.end : res.body.begin,
              category_id: res.body['category'] ? res.body['category']['id'] : null,
              end: res.body.end,
              isTask: 1,
              isCommitment: res.body.commitment,
              category_id_text: res.body['category'] ? res.body['category']['id_text'] : '',
              color: '#4b9ccb',
              allDay: res.body.commitment === 0
            }
            _this.$emit('pushEvent', event)
            this.close()
            // Evento para enviar a nova tarefa para a lista na lateral da agenda.
            this.$socket.emit('generalEvent', {
              data: res.body,
              notBroadcast: true,
              responseEvent: 'addSocketCalendarTask',
              room: `calendar${res.body.user_id}`
            })
            // Evento para enviar a nova tarefa para a tela de consulta de tarefas
            this.$socket.emit('generalEvent', {
              data: res.body,
              responseEvent: 'addSocketItem',
              room: `tasks${res.body.user_id}`
            })
            this.$emit('afterSave')
          },
          err => {
            console.log(err)
            this.loading = false
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível editar o registro de calendário, reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
        } else {
          this.calendar_values.horary_calendar.task_id = this.task.id
          this.$http.post('api/task_calendar', this.calendar_values.horary_calendar).then(
            (res) => {
              let event = {
                id: res.body.id,
                company_id: res.body.company_id,
                task_id: res.body.task.id,
                user_id: res.body.user_id,
                task: res.body.task,
                id_text: res.body.user.id_text,
                user: res.body.user,
                company_id_text: res.body.company.id_text,
                company: res.body.company,
                title: res.body.task.identifier + ' - ' + res.body.task.id_text,
                start: res.body.commitment === 0 ? res.body.end : res.body.begin,
                end: res.body.end,
                isTask: 1,
                isCommitment: res.body.commitment,
                color: '#4b9ccb',
                category_id_text: res.body.task['category'] ? res.body.task['category']['id_text'] : '',
                allDay: !!res.body.all_day
              }
              _this.$emit('pushEvent', event)
              this.close()
            },
            err => {
              console.log(err)
              this.loading = false
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível editar o registro de calendário, reporte o erro.',
                color: 'error',
                dialog: true
              })
            })
        }
      }
    },
    computed: {
      duration: function () {
        if (this.calendar_values.horary_calendar.all_day) {
          return moment.duration(moment(this.calendar_values.horary_calendar.end).diff(this.calendar_values.horary_calendar.begin)).format('D [dias]')
        } else {
          return moment.duration(moment(this.calendar_values.horary_calendar.end).diff(this.calendar_values.horary_calendar.begin)).format('hh [hrs] mm [min]')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PCalendarInsert.vue